module.exports = __webpack_public_path__ + "img/featuredartist (6).1e5b2c5a.jpg";